resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    InsertJson

    InsertJson inserts a string from a json file (via an ajax request) into a span.

    Initialization:

      The parent node requires `data-mogo-ui="InsertJson"` as well as `data-mogo-ui-url="/path/to/data.json"`
      Where the path is the root path to the json data file.

    HTML Structure:

      A `<span data-ajax-json="ex.amp.le"></span>` where the data value is the Json path to the variable.

    Example:

        index.html

          <div data-mogo-ui="InsertJson" data-mogo-ui-url="/json/mydata.json">
            <span data-ajax-json="sample.examle1.title"></span>
            <span data-ajax-json="sample.examle2.title"></span>
          </div>

        json/mydata.json

          {
            "samples": {
              "example1": {
                "title": "This is an example"
              },
              "example2": {
                "title": "This is another example"
              },
            }
          }

        output
          <div data-mogo-ui="InsertJson" data-mogo-ui-url="/json/mydata.json">
            <span data-ajax-json="sample.examle1.title">This is an example</span>
            <span data-ajax-json="sample.examle2.title">This is another example</span>
          </div>

*/

function InsertJson() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.url = null;

  this.init = function() {
    this._jsonRequest();
  }

  this.initAllReady = function() {
    $(this.node).show();
  };

  this._jsonRequest = function() {
    $.ajax({
        url: this.url,
      })

      .done(this._setJsonSpans.bind(this))

      .fail(function() {
        console.log("Ajax failed to fetch data");
      })
  };

  this._setJsonSpans = function(data) {
    var jsonSpanList = $("span[data-ajax-json]", this.node);
    for (var i = 0; i < jsonSpanList.length; i++) {
      var jsonItem = $(jsonSpanList[i]).data("ajax-json");
      $(jsonSpanList[i]).text(this._stringToObjectRef(data, jsonItem));
    }
  };

  this._stringToObjectRef = function(data, path) {
    var reduced = path.split('.').reduce(function(previousValue, currentValue) {
      return previousValue[currentValue];
    }, data);
    return reduced;
  };
}
